// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"4ef7b9d1","333":"bd468671","623":"de7800b8"}[chunkId] + ".css";
};